export default __webpack_public_path__ + "static/media/addNewIconTab.30f2aec5.svg";